/**
 * ModerationCountdownTimer Component
 *
 * Displays the remaining time in the moderation session TTL.
 * Renders inline inside the ActionBar, turning red when the
 * session is about to expire (≤ 60 seconds remaining).
 */

import { Text } from '@soteria/design-system-ve';
import type { ReactElement } from 'react';

import * as styles from './ModerationCountdownTimer.css';

interface ModerationCountdownTimerProps {
  /** Formatted remaining time (e.g. "4:32") */
  formattedTime: string;
  /** Whether the session is about to expire (≤ 60 s) */
  isExpiringSoon: boolean;
}

/** Inline countdown timer for the moderation work queue action bar */
export function ModerationCountdownTimer({ formattedTime, isExpiringSoon }: ModerationCountdownTimerProps): ReactElement {
  return (
    <div aria-label={`Session time remaining: ${formattedTime}`} aria-live="polite" className={styles.timer({ expiring: isExpiringSoon })} role="timer">
      <Text className={styles.timerText({ expiring: isExpiringSoon })}>{formattedTime}</Text>
    </div>
  );
}
